import { render, staticRenderFns } from "./MsdsModule.vue?vue&type=template&id=26eeab2e&scoped=true"
import script from "./MsdsModule.vue?vue&type=script&lang=js"
export * from "./MsdsModule.vue?vue&type=script&lang=js"
import style0 from "./MsdsModule.vue?vue&type=style&index=0&id=26eeab2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26eeab2e",
  null
  
)

export default component.exports